var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.login)?_c('LoginForm'):_vm._e(),(!_vm.login)?_c('SignupForm'):_vm._e(),_vm._v(" "+_vm._s(_vm.formMessage)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.showLoginOrRegister(_vm.login)}}},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }